function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import OutlineButtonComponent from "../../outline-button/outline-button-component";
import MenuComponent from "/components/core/menu/menu-component";
import { withGenericConfig } from "contexts/generic-config-context";
import { StylesMenuItem } from "./top-bar-desktop-link-with-menu-component.scss";
class TopBarDesktopLinkWithMenuComponent extends PureComponent {
    isLinkItemSelected(linkItemText) {
        const { activeLinkText } = this.props;
        return linkItemText === activeLinkText;
    }
    contentRenderer() {
        const { menuItems, hoverColor, translate } = this.props;
        const menuItemsText = Object.keys(menuItems.links);
        const bottomLinksText = menuItems.bottomLinks ? Object.keys(menuItems.bottomLinks) : [];
        return /*#__PURE__*/ _jsxs(StylesMenuItem, {
            hoverColor: hoverColor,
            className: "menu-links-wrapper",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "menu-links-items",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "menu-links",
                        children: menuItemsText.map((menuItemText)=>{
                            const menuItemUrl = menuItems.links[menuItemText];
                            return /*#__PURE__*/ _jsx("div", {
                                className: classnames("menu-link-item", {
                                    selected: this.isLinkItemSelected(menuItemText)
                                }),
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: menuItemUrl,
                                    children: translate(menuItemText)
                                })
                            }, menuItemText);
                        })
                    })
                }),
                bottomLinksText.length > 0 && /*#__PURE__*/ _jsx("div", {
                    className: "bottom-link",
                    children: bottomLinksText.map((buttomLinkText)=>/*#__PURE__*/ _jsx("a", {
                            className: classnames("button-link-item", {
                                selected: this.isLinkItemSelected(buttomLinkText)
                            }),
                            href: menuItems.bottomLinks[buttomLinkText],
                            children: translate(buttomLinkText)
                        }, buttomLinkText))
                })
            ]
        });
    }
    outlineButtonRenderer() {
        const { button, children } = this.props;
        return children ? children : /*#__PURE__*/ _jsx(OutlineButtonComponent, _object_spread({}, button));
    }
    render() {
        const menuProps = {
            contentRenderer: this.contentRenderer
        };
        return /*#__PURE__*/ _jsx("div", {
            className: "top-bar-desktop-menu-component",
            children: /*#__PURE__*/ _jsx(MenuComponent, {
                buttonRenderer: this.outlineButtonRenderer,
                menu: menuProps
            })
        });
    }
    constructor(props){
        super(props);
        this.outlineButtonRenderer = this.outlineButtonRenderer.bind(this);
        this.contentRenderer = this.contentRenderer.bind(this);
    }
}
export default withGenericConfig(TopBarDesktopLinkWithMenuComponent);
